import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { AppConfigService } from 'src/app/services/app-config.service';
import { handleError } from 'src/app/shared/functions/error-handler';
import { IAppConfig } from 'src/app/shared/interfaces/app-config';
import { AgencyList, VwAgency } from '../interface/agency-list';
import { VwCompleteWorklist } from '../../administration/interfaces/complete-worklist';
import { VwMdeWaitlist } from '../../administration/interfaces/mde-waitlist';
import { AgencyRequest } from '../../administration/interfaces/add-to-worklist';
import { WaitlistRequest } from '../models/waitlist-request';
import { WorklistSearch } from '../../administration/interfaces/worklist-search';
import { VwLcgmsSeitLocation } from '../../administration/interfaces/lcgms-seit-location';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  public getGobalWorklist(): Observable<VwCompleteWorklist[]> {
    return this.http
      .get<VwCompleteWorklist[]>(`${this.config.apiUrl}/MDE/Worklist`)
      .pipe(catchError(handleError));
  }

  public getMdeWaitlist(agencySk: string): Observable<VwMdeWaitlist[]> {
    return this.http
      .get<VwMdeWaitlist[]>(`${this.config.apiUrl}/MDE/Waitlist/` + agencySk)
      .pipe(catchError(handleError));
  }

  // TODO: There is no endpoint in the backend that takes in the `agencySk` from the route, only the request.
  public addToMDEWaitlist(
    agencySk: string,
    request: AgencyRequest[]
  ): Observable<boolean> {
    return this.http
      .post<boolean>(
        `${this.config.apiUrl}/MDE/AddToWorklist/${agencySk}`,
        request
      )
      .pipe(catchError(handleError));
  }

  // TODO: This method needs to be updated to only pass in the parameter of `AgencyRequest` as this is the only parameter the backend accepts.
  // I believe the `studentSk` and `agencySk` are not needed.
  public addToWaitlist(
    studentSk: string,
    agencySk: string,
    request: AgencyRequest
  ): Observable<boolean> {
    return this.http
      .post<boolean>(
        `${this.config.apiUrl}/MDE/AddToWaitlist/${studentSk}/${agencySk}`,
        request
      )
      .pipe(catchError(handleError));
  }

  // TODO: This method should return `Observable<AgencyList[]>` but currently getting errors, will need to fix at a later point in time.
  public getMdeAgency(): Observable<any> {
    return this.http
      .get<any>(`${this.config.apiUrl}/MDE/MDEAgencies`)
      .pipe(catchError(handleError));
  }

  public saveMdeAgency(request: AgencyList): Observable<boolean> {
    return this.http
      .post<boolean>(`${this.config.apiUrl}/MDE/Agency`, request)
      .pipe(catchError(handleError));
  }

  public getAgencyDetails(studentSk: string): Observable<VwAgency[]> {
    return this.http
      .get<VwAgency[]>(
        `${this.config.apiUrl}/MDE/GetMDEListByStudentSk/` + studentSk
      )
      .pipe(catchError(handleError));
  }

  public getMdeAgencyByAgencySk(agencySk: string): Observable<AgencyList> {
    return this.http
      .get<AgencyList>(`${this.config.apiUrl}/MDE/MDEAgency/${agencySk}`)
      .pipe(catchError(handleError));
  }

  // TODO: I dont think the `agencySk` is needed here, as the backend only accepts the `request` parameter.
  public removeFromWaitlist(
    agencySk: string,
    request: AgencyList[]
  ): Observable<boolean> {
    return this.http
      .post<boolean>(
        `${this.config.apiUrl}/MDE/RemoveFromWaitlist/${agencySk}`,
        request
      )
      .pipe(catchError(handleError));
  }

  public addToMDWaitlist(request: WaitlistRequest): Observable<boolean> {
    return this.http
      .post<boolean>(`${this.config.apiUrl}/MDE/AddToMDEWaitlist`, request)
      .pipe(catchError(handleError));
  }

  public getStudentSearchDetails(
    request: WorklistSearch
  ): Observable<VwCompleteWorklist[]> {
    return this.http
      .post<VwCompleteWorklist[]>(`${this.config.apiUrl}/MDE/Worklist`, request)
      .pipe(catchError(handleError));
  }

  public searchAgencyList(
    agencyName: string,
    locationCode: string
  ): Observable<VwLcgmsSeitLocation[]> {
    const params: HttpParams = new HttpParams()
      .set('agencyName', agencyName)
      .set('loctionCode', locationCode);
    return this.http
      .get<VwLcgmsSeitLocation[]>(
        `${this.config.apiUrl}/MDE/SearchSEITLocations`,
        { params }
      )
      .pipe(catchError(handleError));
  }

  // TODO: was not able to find this endpoint in the backend
  public getEvaluatorProvidersByAgency(agencySk: string): Observable<any> {
    return this.http
      .get(
        `${this.config.apiUrl}/AgencyManagement/EvaluatorProvidersByAgency/${agencySk}`
      )
      .pipe(catchError(handleError));
  }
}
